import {
  Skeleton,
  SkeletonCircle,
  SkeletonText
} from '@/components/ui/skeleton'
import { Stack } from '.'

export { Skeleton, SkeletonCircle, SkeletonText }

export function SkeletonBulletList ({ count = 3 }) {
  const elem = (
    <Stack direction='row' gap={5}>
      <SkeletonCircle size='12' />
      <Stack flex={1}>
        <Skeleton height='4' />
        <Skeleton height='4' width='80%' />
      </Stack>
    </Stack>
  )
  return Array(count).fill(elem)
}
